/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VerifySecondaryPasswordDto } from '../../models/verify-secondary-password-dto';

export interface SecureControllerVerifySecondaryPassword$Params {
  centerId: string;
      body: VerifySecondaryPasswordDto
}

export function secureControllerVerifySecondaryPassword(http: HttpClient, rootUrl: string, params: SecureControllerVerifySecondaryPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, secureControllerVerifySecondaryPassword.PATH, 'post');
  if (params) {
    rb.path('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

secureControllerVerifySecondaryPassword.PATH = '/api/secure/center/{centerId}/secondary-password/verify';
